export default __webpack_public_path__ + "static/media/twitter.75468c40.svg";